import React from 'react';
import { filterableColumnBuilder } from 'works/legacy/lib/table-filters-helper';
import { Col, Row, Table, Typography } from 'antd';
import { ContentContainer } from '@common/components';
import { ComplianceAssignmentFragmentType } from '@onboarding/graphql';
import { Colors } from 'works/legacy/lib/style-helper';
const { Text } = Typography;

type Props = {
  worksListTemplateName: string;
  assignmentsToBeLinked: ComplianceAssignmentFragmentType[];
};

export function ComplianceLinkAssignmentsSummary({
  worksListTemplateName,
  assignmentsToBeLinked,
}: Props) {
  const tableColumns = [
    column({
      key: 'worksProfile',
      title: 'Name',
      dataIndex: ['worksProfile', 'fullName'],
    }),
    column({
      key: 'supplier',
      dataIndex: ['supplier', 'name'],
      title: 'Supplier',
    }),
    column({
      key: 'organizationUnit',
      dataIndex: ['organizationUnit', 'costCenter'],
      title: 'Cost Center',
    }),
    column({
      key: 'organizationUnit',
      dataIndex: ['organizationUnit', 'name'],
      title: 'Unit',
    }),
    column({
      key: 'worksList',
      dataIndex: ['worksList', 'name'],
      title: 'Linked Compliance List',
      render: (value) => {
        return (
          <Row>
            <Col>
              <Text
                style={{ color: Colors.midnightLighter, paddingRight: '8px' }}
                delete
              >
                {value || 'Unlinked Compliance List'}
              </Text>
            </Col>
            <Col>
              <Text style={{ color: Colors.grassMid, fontWeight: 800 }}>
                {worksListTemplateName}
              </Text>
            </Col>
          </Row>
        );
      },
    }),
  ];

  return (
    <ContentContainer title={`Linking ${worksListTemplateName} Summary`}>
      <Table columns={tableColumns} dataSource={assignmentsToBeLinked} />
    </ContentContainer>
  );
}

const column = filterableColumnBuilder<ComplianceAssignmentFragmentType>({});
